export default {
  BT_HDP: "គូប្រកួតផ្ដល់ហាន់ឌីខាប់ | HDP",
  BT_OU: "លើស/ក្រោម | O/U",
  BT_ML: "Moneyline",
  BT_1X2: "1X2",
  BT_1X2HDP: "3 វិធីផ្ដល់ហាន់ឌីខាប់",
  BT_CS: "ពិន្ទុត្រឹមត្រូវ",
  BT_OE: "គូ/សេស | O/E",
  BT_DC: "ឱកាសទ្វេដង",
  BT_HTFT: "ពាក់កណ្ដាល/ពេញម៉ោង",
  BT_FGLG: "គ្រាប់ទីមួយ/គ្រាប់ចុងក្រោយ",
  BT_TG: "គ្រាប់បាល់សរុប",
  BT_OR: "ជើងឯកទាំងមូល",
  BT_ORZ: "ជើងឯកទាំងមូល",

  BT_ANB: "ក្រុមអ الضៀរមិនមានភ្នាល់",
  BT_BS: "ទាំងពីរឬក្រុមណាមួយឬគ្មានក្រុមណាមួយស៊ុតបញ្ចូល",
  BT_CL: "រក្សាសុទ្ធ",
  BT_DNB: "ស្មើមិនគិត",
  BT_DNBH: "ពាក់កណ្ដាលពេល. ស្មើមិនគិត",
  BT_HNB: "ក្រុមម្ចាស់ផ្ទះមិនមានភ្នាល់",
  BT_TWTN: "ឈ្នះដោយគ្មានអោយស៊ុតបញ្ចូល",

  BT_HDPF: "ពេញម៉ោង. ផ្ដល់ហាន់ឌីខាប់ | FT. HDP",
  BT_OUF: "ពេញម៉ោង. លើស/ក្រោម | FT. O/U",
  BT_MLF: "ពេញម៉ោង. Moneyline | FT. ML",
  BT_1X2F: "ពេញម៉ោង. 1X2",
  BT_1X2HDPF: "ពេញម៉ោង. 3 វិធីផ្ដល់ហាន់ឌីខាប់",
  BT_CSF: "ពេញម៉ោង. ពិន្ទុត្រឹមត្រូវ",
  BT_OEF: "ពេញម៉ោង. គូ/សេស | FT. O/E",
  BT_DCF: "ពេញម៉ោង. ឱកាសទ្វេដង",
  BT_FGLGF: "ពេញម៉ោង. គ្រាប់ទីមួយ/ចុងក្រោយ",
  BT_TGF: "ពេញម៉ោង. គ្រាប់បាល់សរុប",

  BT_HDPH: "ពាក់កណ្ដាលពេល. ផ្ដល់ហាន់ឌីខាប់ | HT. HDP",
  BT_OUH: "ពាក់កណ្ដាលពេល. លើស/ក្រោម | HT. O/U",
  BT_MLH: "ពាក់កណ្ដាលពេល. Moneyline | HT. ML",
  BT_1X2H: "ពាក់កណ្ដាលពេល. 1X2",
  BT_1X2HDPH: "ពាក់កណ្ដាលពេល. 3 វិធីផ្ដល់ហាន់ឌីខាប់",
  BT_CSH: "ពាក់កណ្ដាលពេល. ពិន្ទុត្រឹមត្រូវ",
  BT_OEH: "ពាក់កណ្ដាលពេល. គូ/សេស | HT. O/E",
  BT_DCH: "ពាក់កណ្ដាលពេល. ឱកាសទ្វេដង",
  BT_FGLGH: "ពាក់កណ្ដាលពេល. គ្រាប់ទីមួយ/ចុងក្រោយ",
  BT_TGH: "ពាក់កណ្ដាលពេល. គ្រាប់បាល់សរុប",

  BT_O: "លើស",
  BT_U: "ក្រោម",
  BT_ODD: "សេស",
  BT_EVEN: "គូ",

  BT_HDPOU: "ហាន់ឌីខាប់ & លើស/ក្រោម",
  BT_PARLAY: "ភ្នាល់បញ្ចូលគ្នា",
  BT_FT: "ពេញម៉ោង. ",
  BT_1H: "ពាក់កណ្ដាលពេល. ",
  BT_2H: "ពាក់កណ្ដាលទីពីរ. ",

  BT_FG: "គ្រាប់ទីមួយ",
  BT_LG: "គ្រាប់ចុងក្រោយ",
  BT_HFG: "គ្រាប់ទីមួយដោយម្ចាស់ផ្ទះ",
  BT_AFG: "គ្រាប់ទីមួយដោយភ្ញៀវ",
  BT_HLG: "គ្រាប់ចុងក្រោយដោយម្ចាស់ផ្ទះ",
  BT_ALG: "គ្រាប់ចុងក្រោយដោយភ្ញៀវ",
  BT_NG: "គ្មានគ្រាប់បាល់",
  BT_HY: "ម្ចាស់ផ្ទះ បាទ/ចាស",
  BT_HN: "ម្ចាស់ផ្ទះ ទេ",
  BT_AY: "ភ្ញៀវ បាទ/ចាស",
  BT_AN: "ភ្ញៀវ ទេ",
  BT_H: "ម្ចាស់ផ្ទះ",
  BT_A: "ភ្ញៀវ",
  BT_D: "ស្មើ",
  BT_HD_DC: "ម្ចាស់ផ្ទះ/ស្មើ",
  BT_HA_DC: "ម្ចាស់ផ្ទះ/ភ្ញៀវ",
  BT_DA_DC: "ស្មើ/ភ្ញៀវ",
  BT_HH: "ម្ចាស់ផ្ទះ/ម្ចាស់ផ្ទះ",
  BT_HD: "ម្ចាស់ផ្ទះ/ស្មើ",
  BT_HA: "ម្ចាស់ផ្ទះ/ភ្ញៀវ",
  BT_DH: "ស្មើ/ម្ចាស់ផ្ទះ",
  BT_DD: "ស្មើ/ស្មើ",
  BT_DA: "ស្មើ/ភ្ញៀវ",
  BT_AH: "ភ្ញៀវ/ម្ចាស់ផ្ទះ",
  BT_AD: "ភ្ញៀវ/ស្មើ",
  BT_AA: "ភ្ញៀវ/ភ្ញៀវ",

  BT_Y: "បាទ/ចាស",
  BT_N: "ទេ",

  BT_LIVE: "ផ្សាយបន្តផ្ទាល់",
  BT_HT: "ពាក់កណ្ដាលពេល",
  BT_DELAYED: "ពន្យារ",
  BT_PEN: "បាល់ប៉េណាល់ទី",

  BT_FT1: "ពេញម៉ោង.1",
  BT_FT2: "ពេញម៉ោង.2",
  BT_FTX: "ពេញម៉ោង.X",
  BT_HT1: "ពាក់កណ្ដាល.1",
  BT_HT2: "ពាក់កណ្ដាល.2",
  BT_HTX: "ពាក់កណ្ដាល.X",

  BT_BOTH: "ទាំងពីរ",
  BT_ONE: "មួយ",

  BS_HDP: "ពេញម៉ោង ហាំងឌីកែប",
  BS_HDPH: "ពាក់កណ្ដាលពេល ហាំងឌីកែប",
  BS_OU: "ពេញម៉ោង លើស/ក្រោម",
  BS_OUH: "ពាក់កណ្ដាលពេល លើស/ក្រោម",
  BS_OE: "ពេញម៉ោង សេស/គូ",
  BS_OEH: "ពាក់កណ្ដាលពេល សេស/គូ",
  BS_1X2: "ពេញម៉ោង 1X2",
  BS_1X2H: "ពាក់កណ្ដាលពេល 1X2",
  BS_ML: "ពេញម៉ោង លទ្ធផលផ្ទាល់",
  BS_MLH: "ពាក់កណ្ដាលពេល លទ្ធផលផ្ទាល់",
  BS_1X2HDP: "ពេញម៉ោង 3 ជម្រើស ហាំងឌីកែប",
  BS_1X2HDPH: "ពាក់កណ្ដាលពេល 3 ជម្រើស ហាំងឌីកែប",
  BS_CS: "ពេញម៉ោង លទ្ធផលត្រឹមត្រូវ",
  BS_CSH: "ពាក់កណ្ដាលពេល លទ្ធផលត្រឹមត្រូវ",
  BS_DC: "ពេញម៉ោង ឱកាសទ្វេដង",
  BS_DCH: "ពាក់កណ្ដាលពេល ឱកាសទ្វេដង",
  BS_FGLG: "ពេញម៉ោង គ្រាប់ទីមួយ/ចុងក្រោយ",
  BS_FGLGH: "ពាក់កណ្ដាលពេល គ្រាប់ទីមួយ/ចុងក្រោយ",
  BS_TG: "ពេញម៉ោង គ្រាប់បាល់សរុប",
  BS_TGH: "ពាក់កណ្ដាលពេល គ្រាប់បាល់សរុប",
  BS_ANB: "ភ្ញៀវ មិនមានភ្នាល់",
  BS_HTFT: "ពាក់កណ្ដាល/ពេញម៉ោង",
  BS_BS: "ទាំងពីរ/មួយ/គ្មាន ក្រុមស៊ុតចូល",
  BS_CL: "គ្មានគ្រាប់បាល់",
  BS_DNB: "ស្មើ មិនមានភ្នាល់",
  BS_DNBH: "HT. ស្មើ មិនមានភ្នាល់",
  BS_HNB: "ម្ចាស់ផ្ទះ មិនមានភ្នាល់",
  BS_TWTN: "ឈ្នះដោយគ្មានបញ្ចេញគ្រាប់",
  BS_OR: "ជើងឯក",
  BS_ORZ: "ជើងឯក",

  LOT_BS: "ធំ/តូច",
  LOT_BIG: "ធំ",
  LOT_SMALL: "តូច",
  LOT_OE: "សេស/គូ",
  LOT_ODD: "សេស",
  LOT_EVEN: "គូ",
  LOT_OU: "លើស/ក្រោម",
  LOT_OVER: "លើស",
  LOT_UNDER: "ក្រោម",
  LOT_FT: "ពេញម៉ោង",
  LOT_HT: "ពាក់កណ្ដាលពេល",

  BT_ALLBT: "ប្រភេទភ្នាល់ទាំងអស់",

  D_1: "លេខតែមួយ",
  D_2: "លេខ និងច្រាស",
  D_3: "ប្រអប់",
  D_4: "iBox",
  D_5: "ប្រអប់ 3 ខ្ទង់ចុងក្រោយ",
  D_6: "ប្រអប់ 2 ខ្ទង់ចុងក្រោយ",

  D_BIG: "ធំ",
  D_SMALL: "តូច",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "ម្ចាស់ផ្ទះ",
  LOT_0: "ភ្ញៀវ",

  BT_KO: "វាយឲ្យសន្លប់ដោយ",

  ODD_Home: "ម្ចាស់ផ្ទះ",
  ODD_Away: "ភ្ញៀវ",
  ODD_Draw: "ស្មើ",
  ODD_Over: "លើស",
  ODD_Under: "ក្រោម",
  ODD_Odd: "សេស",
  ODD_Even: "គូ",

  GH_1X2: "ឈ្នះ",
  GH_1X20: "ឈ្នះ",
  GH_1X2HDP: "ជាប់ទី",
  GH_1X2HDP2: "ទី 1",
  GH_1X2HDP4: "ទី 2",
  GH_OVER: "លើស (4,5,6)",
  GH_UNDER: "ក្រោម (1,2,3)",
  GH_ODD: "សេស (1,3,5)",
  GH_EVEN: "គូ (2,4,6)",
  GH_OU1: "លើស (4,5,6)",
  GH_OU2: "ក្រោម (1,2,3)",
  GH_OE1: "សេស (1,3,5)",
  GH_OE2: "គូ (2,4,6)",

  GX_1X2: "ឈ្នះ",
  GX_1X20: "ឈ្នះ",
  GX_1X2HDP: "ជាប់ទី",
  GX_1X2HDP2: "ទី 1",
  GX_1X2HDP4: "ទី 2",
  GX_OVER: "លើស (7-12)",
  GX_UNDER: "ក្រោម (1-6)",
  GX_ODD: "សេស (1,3,5,7,9,11)",
  GX_EVEN: "គូ (2,4,6,8,10,12)",
  GX_OU1: "លើស (7-12)",
  GX_OU2: "ក្រោម (1-6)",
  GX_OE1: "សេស (1,3,5,7,9,11)",
  GX_OE2: "គូ (2,4,6,8,10,12)",

  GC_OU: "O/U",
  GC_OE: "O/E",
  GC_OVER: "លើស (3,4,5)",
  GC_UNDER: "ក្រោម (0,1,2)",
  GC_ODD: "សេស (1,3,5)",
  GC_EVEN: "គូ (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "បាល់ទី 1",
  GC_1X20: "ឈ្នះ",
  GC_ML: "បាល់ទី 1",
  GC_1X2: "ឈ្នះ",
  GC_OU1: "លើស (3,4,5)",
  GC_OU2: "ក្រោម (0,1,2)",
  GC_OE1: "សេស (1,3,5)",
  GC_OE2: "គូ (0,2,4)",

  GR_RED: "RED (1)",
  GR_YELLOW: "YELLOW (2)",
  GR_BLUE: "BLUE (3)",
  GR_GREEN: "GREEN (4)",
  GR_OVER: "លើស (3,4)",
  GR_UNDER: "ក្រោម (1,2)",
  GR_ODD: "សេស (1,3)",
  GR_EVEN: "គូ (2,4)",
  GR_SINGLE: "SINGLE",
  GR_PAIR: "PAIR",
  GR_TRIPS: "TRIPS",
  GR_ADVANCED: "ADVANCED",
  GR_ELIMINATED: "ELIMINATED",
  GR_HIT1: "HIT 1",
  GR_HIT2: "HIT 2",
  GR_PERFECT: "PERFECT",
  GR_MLHOME: "ADVANCED",
  GR_MLAWAY: "ELIMINATED",
  GR_1X2FT1: "SINGLE",
  GR_1X2FTX: "PAIR",
  GR_1X2FT2: "TRIPS",
  GR_ML1: "ADVANCED",
  GR_ML2: "ELIMINATED",
  GR_1X21: "SINGLE",
  GR_1X22: "TRIPS",
  GR_1X23: "PAIR",
  GR_OU1: "លើស (3,4)",
  GR_OU2: "ក្រោម (1,2)",
  GR_OE1: "សេស (1,3)",
  GR_OE2: "គូ (2,4)",

  ROOM_A: "បើក",
  ROOM_0: "សកម្ម",
  ROOM_1: "បិទ",
  ROOM_2: "បោះបង់",
  ROOM_3: "បញ្ចប់",
  ROOM_4: "បញ្ឈប់ការភ្នាល់",
  ROOM_10: "ទាំងអស់",

  ROOM_T0: "ទាំងអស់",
  ROOM_T1: "បន្ទប់សាធារណៈ",
  ROOM_T2: "បន្ទប់ឯកជន",
  ROOM_T3: "លេងដើម្បីរកប្រាក់",

  joinRoom1: "ចូលបន្ទប់សាធារណៈ",
  joinRoom2: "ចូលបន្ទប់ឯកជន",
  joinRoom3: "ចូលបន្ទប់លេងដើម្បីរកប្រាក់",
  createRoom1: "បង្កើតបន្ទប់សាធារណៈ",
  createRoom2: "បង្កើតបន្ទប់ឯកជន",
  createRoom3: "បង្កើតបន្ទប់លេងដើម្បីរកប្រាក់",
  Champion: "ជើងឯក",
  FirstRunnerUp: "ទី 2",
  SecondRunnerUp: "ទី 3",

  BT_OEHM: "ម្ចាស់ផ្ទះ សេស/គូ",
  BT_OEHMH: "ក្រោមពាក់កណ្តាល ម៉ោង ម្ចាស់ផ្ទះ សេស/គូ",
  BT_OEAW: "ភ្ញៀវ សេស/គូ",
  BT_OEAWH: "ក្រោមពាក់កណ្តាល ម៉ោង ភ្ញៀវ សេស/គូ",

  BS_OEHM: "ពេញម៉ោង ម្ចាស់ផ្ទះ សេស/គូ",
  BS_OEHMH: "ក្រោមពាក់កណ្តាល ម៉ោង ម្ចាស់ផ្ទះ សេស/គូ",
  BS_OEAW: "ពេញម៉ោង ភ្ញៀវ សេស/គូ",
  BS_OEAWH: "ក្រោមពាក់កណ្តាល ម៉ោង ភ្ញៀវ សេស/គូ",

  MB_OVER: "លើស (4,5,6)",
  MB_UNDER: "ក្រោម (1,2,3)",
  MB_ODD: "សេស (1,3,5)",
  MB_EVEN: "គូ (2,4,6)",

  BS_1X2OU: "1X2 + OU",
  BT_1X2OU: "1X2 + OU",
  BT_1O: "1លើស",
  BT_1U: "1ក្រោម",
  BT_2O: "2លើស",
  BT_2U: "2ក្រោម",
  BT_XO: "Xលើស",
  BT_XU: "Xក្រោម",

  BS_DCOU: "ឱកាសទ្វេ + OU",
  BT_DCOU: "ឱកាសទ្វេ + OU",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "OU + OE",
  BT_OUOE: "OU + OE",
  BK_OO: "លើស/សេស",
  BK_OE: "លើស/គូ",
  BK_UO: "ក្រោម/សេស",
  BK_UE: "ក្រោម/គូ",

  BS_HTFTOE: "ពាក់កណ្ដាល/ពេញម៉ោង + សេស/គូ",
  BT_HTFTOE: "ពាក់កណ្ដាល/ពេញម៉ោង + សេស/គូ",
  BK_EO: "គូ/សេស",
  BK_EE: "គូ/គូ",

  BS_WM: "ឈ្នះដោយភាពខុសគ្នា",
  BT_WM: "ឈ្នះដោយភាពខុសគ្នា",
  BK_H1: "ម្ចាស់ផ្ទះ 1",
  BK_H2: "ម្ចាស់ផ្ទះ 2",
  BK_H3Up: "ម្ចាស់ផ្ទះ 3+",
  BK_A1: "ភ្ញៀវ 1",
  BK_A2: "ភ្ញៀវ 2",
  BK_A3Up: "ភ្ញៀវ 3+",
  BK_D: "ស្មើមានគ្រាប់បាល់ (មិនរាប់ 0-0)",
  BK_NG: "គ្មានគ្រាប់បាល់",

  BS_ETG: "ចំនួនគ្រាប់បាល់ច្បាស់លាស់",
  BT_ETG: "ចំនួនគ្រាប់បាល់ច្បាស់លាស់",
  BS_EHTG: "ចំនួនគ្រាប់បាល់ម្ចាស់ផ្ទះច្បាស់លាស់",
  BT_EHTG: "ចំនួនគ្រាប់បាល់ម្ចាស់ផ្ទះច្បាស់លាស់",
  BS_EATG: "ចំនួនគ្រាប់បាល់ភ្ញៀវច្បាស់លាស់",
  BT_EATG: "ចំនួនគ្រាប់បាល់ភ្ញៀវច្បាស់លាស់",
  BS_ETGH: "ក្រោមពាក់កណ្ដាល ម៉ោង ចំនួនគ្រាប់ច្បាស់លាស់",
  BT_ETGH: "ក្រោមពាក់កណ្ដាល ម៉ោង ចំនួនគ្រាប់ច្បាស់លាស់",
  BS_EHTGH: "ក្រោមពាក់កណ្ដាល ម៉ោង ម្ចាស់ផ្ទះ ច្បាស់លាស់",
  BT_EHTGH: "ក្រោមពាក់កណ្ដាល ម៉ោង ម្ចាស់ផ្ទះ ច្បាស់លាស់",
  BS_EATGH: "ក្រោមពាក់កណ្ដាល ម៉ោង ភ្ញៀវ ច្បាស់លាស់",
  BT_EATGH: "ក្រោមពាក់កណ្ដាល ម៉ោង ភ្ញៀវ ច្បាស់លាស់",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "ពាក់កណ្ដាល/ពេញម៉ោង លទ្ធផលត្រឹមត្រូវ",
  BS_CSHTFT: "ពាក់កណ្ដាល/ពេញម៉ោង លទ្ធផលត្រឹមត្រូវ",
  BT_ETGHTFT: "ពាក់កណ្ដាល/ពេញម៉ោង ចំនួនគ្រាប់ច្បាស់លាស់",
  BS_ETGHTFT: "ពាក់កណ្ដាល/ពេញម៉ោង ចំនួនគ្រាប់ច្បាស់លាស់",

  CF_CS_2_1: "២-១",
  CF_CS_2_0: "២-០",
  CF_CS_0_2: "០-២",
  CF_CS_1_2: "១-២",
  CF_R_1_W: "អ្នកឈ្នះជុំទី១",
  CF_R_2_W: "អ្នកឈ្នះជុំទី២",
  CF_R_3_W: "អ្នកឈ្នះជុំទី៣",
  CF_MLHOME: "ក្រុមម្ចាស់ផ្ទះឈ្នះ",
  CF_MLAWAY: "ក្រុមភ្ញៀវឈ្នះ",
  CF_EVEN: "ការប្រកួត ២ ជុំ",
  CF_ODD: "ការប្រកួត ៣ ជុំ",
  CF_ML1: "ក្រុមម្ចាស់ផ្ទះឈ្នះ",
  CF_ML2: "ក្រុមភ្ញៀវឈ្នះ",
  CF_ML: "ឈ្នះឯកតា",
  CF_CS: "លទ្ធផលត្រឹមត្រូវ",
  CF_OE: "គូ/សេស",
  CF_0: "ស្មើ",
  CF_1: "ម្ចាស់ផ្ទះ",
  CF_2: "ភ្ញៀវ",
  CF_OE1: "គូ",
  CF_OE2: "សេស",
    
  EF8_R1_1STBOOM: "អ្នកឈ្នះជុំទី១ (1st Boom)",
  EF8_R2_1STBOOM: "អ្នកឈ្នះជុំទី២ (1st Boom)",
  EF8_R3_1STBOOM: "អ្នកឈ្នះជុំទី៣ (1st Boom)",
  EF8_0: "-",
  EF8_1: "ម្ចាស់ផ្ទះ",
  EF8_2: "ភ្ញៀវ",

};